import { parseFeaturePreferences } from "../context/featurePreferences";

function storageKey(adminId) {
    return `sms.adminFeaturePreferences.${adminId}`;
}

export function readAdminFeaturePreferences(adminId) {
    if (!adminId) return null;
    try {
        const raw = localStorage.getItem(storageKey(adminId));
        if (!raw) return null;
        return parseFeaturePreferences(JSON.parse(raw));
    } catch {
        return null;
    }
}

export function writeAdminFeaturePreferences(adminId, preferences) {
    if (!adminId || !preferences) return;
    try {
        localStorage.setItem(storageKey(adminId), JSON.stringify(preferences));
    } catch {
        /* ignore quota errors */
    }
}

export function clearAdminFeaturePreferences(adminId) {
    if (!adminId) return;
    try {
        localStorage.removeItem(storageKey(adminId));
    } catch {
        /* ignore */
    }
}
